//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { IncludesStream } from './IncludesStream';

export class SchoolInvoiceLogoUpdateItem extends IncludesStream {

    constructor(initializer?: Partial<SchoolInvoiceLogoUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "SchoolInvoiceLogoUpdateItem";
}
